/**
 * Die Quizfragen der Lernstrecke — fünf je Kapitel, eine richtige Antwort.
 *
 * Aus dem freigegebenen Entwurf übernommen (Skills4Retail, 22.08.2026).
 * `q` Frage · `o` Antwortmöglichkeiten · `c` Nummer der richtigen · `e`
 * Erklärung, die nach dem Prüfen erscheint.
 *
 * Die Hürde steht **nicht** hier, sondern in den Einstellungen — sie kommt vom
 * Server mit der Antwort auf `GET /student/concept`.
 */

export const QUIZZES = {
	1: [
		{
			q: 'Euer Shop hatte im Mai 2.400 Besuche und 96 Bestellungen. Wie hoch ist die Conversion Rate?',
			o: ['0,4 %', '4 %', '25 %', '9,6 %'],
			c: 1,
			e: 'Conversion Rate = Bestellungen ÷ Besuche = 96 ÷ 2.400 = 0,04, also 4 %.'
		},
		{
			q: 'Was ist der Unterschied zwischen Upsell und Cross-Sell?',
			o: [
				'Upsell ist Werbung vor dem Kauf, Cross-Sell danach',
				'Upsell empfiehlt das teurere Produkt, Cross-Sell das ergänzende',
				'Upsell gilt online, Cross-Sell im Geschäft',
				'Upsell erhöht die Besuche, Cross-Sell die Conversion Rate'
			],
			c: 1,
			e: 'Upsell = höherwertige Variante desselben Bedarfs. Cross-Sell = passendes Zusatzprodukt. Beide erhöhen den Warenkorbwert.'
		},
		{
			q: 'Wodurch entstehen Kaufabbrüche im Checkout am häufigsten?',
			o: [
				'Zu viele Produktbilder',
				'Überraschende Versandkosten und Registrierungszwang',
				'Ein zu niedriger Preis',
				'Zu viele Zahlungsarten zur Auswahl'
			],
			c: 1,
			e: 'Kosten, die erst an der Kassa auftauchen, und ein erzwungenes Kundenkonto sind die klassischen Abbruchgründe. Deshalb: Versandkosten früh zeigen und Gastbestellung anbieten.'
		},
		{
			q: 'Eure Junior Company verkauft Kerzen über eine Plattform, auf der sonst Privatleute ihre gebrauchten Sachen anbieten. Was gilt für euch?',
			o: [
				'C2C — ihr seid dort Privatpersonen wie alle anderen',
				'B2C — ihr handelt als Unternehmen und tragt dessen Pflichten',
				'B2B, weil die Plattform ein Unternehmen ist',
				'Gar nichts, solange der Umsatz klein bleibt'
			],
			c: 1,
			e: 'Die Plattform ändert nichts an eurer Rolle: Ihr verkauft als Unternehmen an Privatpersonen. Damit gelten Impressum, Preise inklusive Umsatzsteuer und das 14-tägige Rücktrittsrecht — auch dort (Kapitel 3).'
		},
		{
			q: 'Was spricht dafür, zusätzlich zum eigenen Shop auf einem Marktplatz zu verkaufen?',
			o: [
				'Die Provision ist niedriger als die Shop-Gebühr',
				'Das Publikum ist schon da — man muss es nicht erst aufbauen',
				'Man erfährt die Adressen der Kundschaft',
				'Der Auftritt lässt sich freier gestalten'
			],
			c: 1,
			e: 'Reichweite ist der Grund. Bezahlt wird sie mit Provision (meist 5–15 %), mit einer Vorlage statt eigenem Auftritt — und damit, dass die Kundin der Plattform gehört, nicht euch.'
		}
	],
	2: [
		{
			q: 'Welche drei Angaben muss eine Value Proposition enthalten?',
			o: [
				'Preis, Farbe, Verfügbarkeit',
				'Zielgruppe, Problem, warum ausgerechnet ihr es besser löst',
				'Logo, Slogan, Website',
				'Umsatzziel, Gewinn, Marktanteil'
			],
			c: 1,
			e: 'Ohne Adressat, Problem und Abgrenzung ist es ein Werbespruch, keine Value Proposition.'
		},
		{
			q: 'Welche Aussage ist ein brauchbarer USP für eine Junior Company?',
			o: [
				'„Wir bieten beste Qualität zu fairen Preisen."',
				'„Unsere Taschen werden aus alten Schulfahnen der HTL genäht — jede ist ein Einzelstück."',
				'„Wir sind ein innovatives, junges Team."',
				'„Kundenzufriedenheit steht bei uns an erster Stelle."'
			],
			c: 1,
			e: 'Wahr, überprüfbar und von niemandem sonst behauptbar. Die anderen drei kann jede Firma über sich schreiben.'
		},
		{
			q: 'Was gehört NICHT zu den fünf Bestandteilen einer Buyer Persona?',
			o: ['Demografie', 'Kaufverhalten', 'Bevorzugte Online-Kanäle', 'Die Gewinnspanne eures Produkts'],
			c: 3,
			e: 'Die Persona beschreibt die Kundschaft: Demografie, Interessen, Kaufverhalten, Kanäle und ihr Problem. Die Marge ist eure Zahl, nicht ihre.'
		},
		{
			q: 'Warum bekommt eine Persona einen Namen und ein Alter?',
			o: [
				'Weil das Gesetz es verlangt',
				'Damit im Team konkret über eine Person diskutiert werden kann statt abstrakt über „die Zielgruppe"',
				'Damit man sie in der Werbung nennen kann',
				'Weil Suchmaschinen Namen bevorzugen'
			],
			c: 1,
			e: 'Konkretheit ist der ganze Zweck: „Würde Lena das kaufen?" ist beantwortbar, „Würde die Zielgruppe das kaufen?" nicht.'
		},
		{
			q: 'Was hebt ein Konzeptfeld am ehesten von 5 auf 9 Punkte?',
			o: [
				'Mehr Zeichen und längere Sätze',
				'Konkrete Belege: zitierte Aussagen aus zehn Befragungen, Zahlen, Beispiele',
				'Fachbegriffe aus dem Marketing',
				'Eine allgemeine Definition von Buyer Persona am Anfang'
			],
			c: 1,
			e: 'Das Raster belohnt Bezug zur eigenen Junior Company mit konkreten Beispielen und Zahlen — nicht Länge und nicht Theorie.'
		}
	],
	3: [
		{
			q: 'Welche Angabe gehört zwingend ins Impressum eures Shops?',
			o: [
				'Die Anzahl der Mitarbeiter:innen',
				'Name und Anschrift der Junior Company samt E-Mail-Adresse',
				'Der erwartete Jahresumsatz',
				'Die Namen aller Lieferanten'
			],
			c: 1,
			e: 'Das ECG verlangt die Identität und die Erreichbarkeit des Anbieters — Name, Anschrift, E-Mail, Vertretungsberechtigte.'
		},
		{
			q: 'Ab wann läuft die 14-tägige Rücktrittsfrist bei einer Warenbestellung?',
			o: ['Ab dem Klick auf „Bestellen"', 'Ab Erhalt der Ware', 'Ab Bezahlung', 'Ab Versandbestätigung'],
			c: 1,
			e: 'Bei Warenlieferungen beginnt die Frist mit dem Erhalt der Ware. Fehlt die Belehrung über das Rücktrittsrecht, verlängert sich die Frist erheblich.'
		},
		{
			q: 'Für welchen Fall gilt das Rücktrittsrecht typischerweise NICHT?',
			o: [
				'Ein Notizbuch aus eurem Standardsortiment',
				'Eine Tasche mit eingesticktem Wunschnamen',
				'Ein T-Shirt in Größe M',
				'Eine Kerze aus der Serienproduktion'
			],
			c: 1,
			e: 'Nach Kundenwunsch angefertigte oder eindeutig persönlich zugeschnittene Waren sind vom Rücktrittsrecht ausgenommen.'
		},
		{
			q: 'Welcher Cookie darf ohne Einwilligung gesetzt werden?',
			o: [
				'Ein Analyse-Cookie von Google Analytics',
				'Ein Werbe-Cookie von Meta',
				'Der Cookie, der den Warenkorb speichert',
				'Ein Cookie zur Erstellung von Nutzerprofilen'
			],
			c: 2,
			e: 'Technisch notwendige Cookies — Warenkorb, Login, Sprache — brauchen keine Einwilligung. Analyse und Werbung schon.'
		},
		{
			q: 'Warum sind selbst verfasste Fünf-Sterne-Bewertungen im eigenen Shop ein Problem?',
			o: [
				'Sie verschlechtern das Google-Ranking',
				'Sie sind eine irreführende Geschäftspraxis und damit unzulässig',
				'Sie kosten Gebühren',
				'Sie sind erlaubt, wenn man sie nicht kennzeichnet'
			],
			c: 1,
			e: 'Gefälschte Bewertungen täuschen über die tatsächliche Kundenerfahrung — das ist irreführend und nicht bloß ein Stilfehler.'
		}
	],
	4: [
		{
			q: 'Ein Produkt kostet 12 € im Verkauf. Material 3,40 €, Verpackung 0,60 €, Zahlungsgebühr 0,35 €, Fixkostenanteil 1,10 €. Wie hoch ist der Deckungsbeitrag?',
			o: ['5,45 €', '6,55 €', '8,60 €', '12,00 €'],
			c: 1,
			e: '12,00 − 3,40 − 0,60 − 0,35 − 1,10 = 6,55 €. Die eigene Arbeitszeit ist darin noch nicht enthalten.'
		},
		{
			q: 'Was ist der zentrale wirtschaftliche Unterschied zwischen physischen und digitalen Produkten?',
			o: [
				'Digitale Produkte sind immer teurer',
				'Digitale Produkte werden einmal erstellt und beliebig oft ohne Materialkosten verkauft',
				'Physische Produkte brauchen kein Marketing',
				'Digitale Produkte unterliegen keinem Rücktrittsrecht'
			],
			c: 1,
			e: 'Der Aufwand steckt in der Erstellung, nicht in der Vervielfältigung. Physische Produkte verursachen bei jedem Stück erneut Material-, Lager- und Versandkosten.'
		},
		{
			q: 'Welcher Nachteil gehört typischerweise zum Großhandelseinkauf?',
			o: [
				'Die Qualität ist nicht kontrollierbar',
				'Mindestabnahmemengen binden Geld, und andere verkaufen dasselbe Produkt',
				'Die Lieferzeit ist unvorhersehbar',
				'Es ist rechtlich nicht zulässig'
			],
			c: 1,
			e: 'Großhandel ist schnell und planbar, aber die Marge ist dünner, es gibt Mindestmengen — und das Produkt ist nicht exklusiv.'
		},
		{
			q: 'Warum sind Verbrauchsgüter wie Kerzen oder Seifen für eine Junior Company attraktiv?',
			o: [
				'Sie sind vom Rücktrittsrecht ausgenommen',
				'Dieselben Kund:innen kaufen wieder — ein Wiederkauf kostet kein neues Marketing',
				'Sie brauchen keine Verpackung',
				'Sie dürfen ohne Kennzeichnung verkauft werden'
			],
			c: 1,
			e: 'Wiederkäufer:innen sind deutlich billiger als neue Kund:innen: Vertrauen und Bekanntheit sind schon da.'
		},
		{
			q: 'Welche Maßnahme sichert die Qualität am zuverlässigsten?',
			o: [
				'Alle im Team achten gemeinsam darauf',
				'Ein Musterstück als Referenz, Stichproben vor dem Versand und eine namentlich zuständige Person',
				'Ein Hinweis in den AGB',
				'Nur die schönsten Stücke fotografieren'
			],
			c: 1,
			e: 'Verantwortung, die alle haben, hat niemand. Referenzstück, Stichprobe und eine zuständige Person machen Qualität überprüfbar.'
		}
	],
	5: [
		{
			q: 'Wofür spricht ein Mietshop wie Shopify gegenüber einer Open-Source-Lösung?',
			o: [
				'Er ist immer kostenlos',
				'Man ist schnell online und braucht wenig Technikwissen',
				'Er lässt sich beliebig umprogrammieren',
				'Er benötigt kein Impressum'
			],
			c: 1,
			e: 'Mietshops kosten monatlich, sind dafür schnell startklar, werden automatisch aktualisiert und bringen Zahlung und Versand mit. Flexibilität ist ihr Nachteil.'
		},
		{
			q: 'Welche Seiten müssen von jeder Seite eures Shops aus erreichbar sein?',
			o: [
				'Blog und Über uns',
				'Impressum, Datenschutzerklärung, AGB und Widerrufsbelehrung',
				'Nur die Startseite',
				'Die Produktseiten der Bestseller'
			],
			c: 1,
			e: 'Die Pflichtseiten aus Kapitel 3 gehören in den Fußbereich — von überall aus mit einem Klick erreichbar.'
		},
		{
			q: 'Was ist bei Schülershops der häufigste Grund für lange Ladezeiten?',
			o: [
				'Zu viele Kategorien',
				'Unverkleinerte Handyfotos mit mehreren Megabyte',
				'Zu wenige Produkte',
				'Die Verwendung von HTTPS'
			],
			c: 1,
			e: 'Bilder machen den Großteil der Datenmenge aus. Ein 4-MB-Foto auf unter 300 KB verkleinert, ohne dass man einen Unterschied sieht.'
		},
		{
			q: 'Was bedeutet die „Drei-Klick-Regel" für eure Sitemap?',
			o: [
				'Kund:innen dürfen höchstens dreimal klicken, bevor sie zahlen müssen',
				'Jede Seite ist von der Startseite aus in höchstens drei Klicks erreichbar',
				'Es darf höchstens drei Kategorien geben',
				'Jedes Produkt braucht drei Fotos'
			],
			c: 1,
			e: 'Wer tiefer klicken muss, findet nicht — die Struktur soll flach bleiben.'
		},
		{
			q: 'Was gehört auf eine gute Produktseite?',
			o: [
				'Ein Foto, der Preis und sonst nichts',
				'Mehrere Fotos, Maße und Material, Preis inklusive Steuer, sichtbare Versandkosten und ehrliche Verfügbarkeit',
				'Möglichst viele Suchbegriffe im Fließtext',
				'Ein Countdown, damit es schneller geht'
			],
			c: 1,
			e: 'Die Produktseite muss die Fragen beantworten, die im Geschäft jemand persönlich beantworten würde. Künstlicher Zeitdruck ist zudem unzulässige Irreführung.'
		}
	],
	6: [
		{
			q: 'Welche Aufgabe hat ein Payment Gateway?',
			o: [
				'Es lagert die Ware ein',
				'Es verschlüsselt die Zahlungsdaten und holt die Freigabe der Bank ein',
				'Es erstellt die Rechnung für das Finanzamt',
				'Es legt den Verkaufspreis fest'
			],
			c: 1,
			e: 'Der Zahlungsdienstleister vermittelt zwischen Shop und Bank: verschlüsseln, übermitteln, Freigabe holen, Ergebnis zurückmelden.'
		},
		{
			q: 'Eine Kundin schickt euch ihre Kreditkartennummer per E-Mail, damit ihr die Zahlung „schnell erledigt". Was ist richtig?',
			o: [
				'Nummer notieren und im Shop eingeben',
				'Ablehnen und auf die reguläre Bezahlung im Shop verweisen — Kartendaten dürft ihr nie entgegennehmen oder speichern',
				'Nummer im Teamchat teilen, damit es jemand erledigt',
				'Nummer ausdrucken und im Klassenzimmer aufbewahren'
			],
			c: 1,
			e: 'Kartendaten gehören ausschließlich zum Zahlungsdienstleister. Weder E-Mail noch Chat noch Zettel sind dafür zulässig.'
		},
		{
			q: 'Warum ist Vorauskasse per Überweisung als einzige Zahlungsart eine schlechte Idee?',
			o: [
				'Sie ist rechtlich unzulässig',
				'Sie kostet die höchsten Gebühren',
				'Viele brechen den Kauf ab, weil sie in Vorleistung gehen und lange warten müssen',
				'Sie funktioniert nicht am Handy'
			],
			c: 2,
			e: 'Vorauskasse ist für euch risikolos und gratis — aber sie bremst die Conversion stark. Als eine Option von mehreren ist sie in Ordnung.'
		},
		{
			q: 'Was leistet 3-D Secure?',
			o: [
				'Es beschleunigt den Versand',
				'Die zahlende Person bestätigt zusätzlich in ihrer Banking-App, was das Betrugsrisiko verschiebt',
				'Es zeigt Produkte dreidimensional',
				'Es ersetzt die AGB'
			],
			c: 1,
			e: 'Die starke Kundenauthentifizierung ist verpflichtend. Sie schützt vor missbräuchlichen Kartenzahlungen und verlagert das Risiko weg vom Händler.'
		},
		{
			q: 'Wie viele Zahlungsarten sollte eine Junior Company anbieten?',
			o: [
				'Nur eine — das ist am einfachsten',
				'Zwei bis vier, darunter eine gewohnte, eine österreichische und eine gebührenfreie',
				'Möglichst alle verfügbaren',
				'Das ist gesetzlich vorgeschrieben'
			],
			c: 1,
			e: 'Zu wenig Auswahl kostet Bestellungen, zu viel verwirrt an der Kassa. Zwei bis vier gut gewählte Optionen decken die Zielgruppe ab.'
		}
	],
	7: [
		{
			q: 'Bis wann muss das Geld nach einem wirksamen Rücktritt zurückgezahlt werden?',
			o: [
				'Sofort am selben Tag',
				'Binnen 14 Tagen — einschließlich der ursprünglichen Standard-Versandkosten',
				'Binnen drei Monaten',
				'Erst wenn die Ware weiterverkauft wurde'
			],
			c: 1,
			e: 'Rückerstattung binnen 14 Tagen, und zwar auch die Hinsendekosten in Höhe der günstigsten Standardversandart.'
		},
		{
			q: 'Warum solltet ihr Retourengründe systematisch notieren?',
			o: [
				'Weil das Gesetz es verlangt',
				'Weil sich häufende Gründe auf ein Problem bei Produkt oder Beschreibung hinweisen',
				'Um Kund:innen sperren zu können',
				'Damit der Versanddienstleister Rabatt gibt'
			],
			c: 1,
			e: 'Retouren sind Rückmeldungen. Passt die Größe nie, ist die Größentabelle falsch — nicht die Kundschaft.'
		},
		{
			q: 'Warum lohnt sich ein externer Fulfillment-Dienstleister für Junior Companies fast nie?',
			o: [
				'Er ist für Schulen verboten',
				'Die Mengen sind zu klein und die Fixkosten zu hoch',
				'Er übernimmt keine Retouren',
				'Er verlangt eine Gewerbeberechtigung'
			],
			c: 1,
			e: 'Lagern, Packen und Versenden auszulagern rechnet sich erst ab einer Menge, die eine Junior Company in einem Schuljahr nicht erreicht.'
		},
		{
			q: 'Welche Zusage passt am besten zum Schulalltag?',
			o: [
				'„Wir antworten binnen 24 Stunden, auch am Wochenende."',
				'„Wir antworten werktags binnen zwei Tagen."',
				'„Wir sind rund um die Uhr telefonisch erreichbar."',
				'Gar keine Angabe zur Antwortzeit'
			],
			c: 1,
			e: 'Versprecht nur, was ihr im Schulalltag verlässlich haltet. Eine eingehaltene bescheidene Zusage wirkt besser als eine gebrochene große.'
		},
		{
			q: 'Was bewirkt „Gratisversand ab 30 €"?',
			o: [
				'Die Conversion Rate sinkt',
				'Der durchschnittliche Warenkorbwert steigt, weil Leute den Korb bis zur Grenze auffüllen',
				'Die Retourenquote sinkt automatisch',
				'Die Versandkosten entfallen für euch'
			],
			c: 1,
			e: 'Eine Schwelle für Gratisversand ist eines der einfachsten Mittel, den Warenkorbwert zu erhöhen — die Kosten müssen aber in der Marge gedeckt sein.'
		}
	],
	8: [
		{
			q: 'In welcher Reihenfolge arbeitet eine Suchmaschine?',
			o: [
				'Ranking, Crawling, Index',
				'Crawling, Index, Ranking',
				'Index, Ranking, Crawling',
				'Crawling, Ranking, Index'
			],
			c: 1,
			e: 'Erst folgen Bots den Links (Crawling), dann wird das Gelesene geordnet gespeichert (Index), und bei jeder Suchanfrage entscheidet der Algorithmus über die Reihenfolge (Ranking).'
		},
		{
			q: 'Ein Link von der Website eurer Schule auf euren Shop ist …',
			o: ['eine On-Page-Maßnahme', 'eine Off-Page-Maßnahme', 'für das Ranking bedeutungslos', 'unzulässig'],
			c: 1,
			e: 'Alles außerhalb eurer eigenen Seite ist Off-Page. Links von glaubwürdigen Seiten — Schule, Gemeinde, JA Austria, Lokalpresse — bauen Autorität auf.'
		},
		{
			q: 'Welches Keyword ist für eine kleine Junior Company am aussichtsreichsten?',
			o: ['Notizbuch', 'Notizbuch mit Namen Graz', 'Buch', 'Papier'],
			c: 1,
			e: 'Längere, spezifische Suchbegriffe haben weniger Konkurrenz und passendere Suchende. Bei „Notizbuch" konkurriert ihr mit dem gesamten Onlinehandel.'
		},
		{
			q: 'Was passiert bei Keyword-Stuffing?',
			o: [
				'Die Seite steigt im Ranking',
				'Die Seite wird abgewertet, weil die Suchmaschine Manipulation erkennt',
				'Nichts, es ist eine neutrale Technik',
				'Die Seite wird schneller geladen'
			],
			c: 1,
			e: 'Suchbegriffe zu stapeln war vor zwanzig Jahren wirksam. Heute erkennen die Algorithmen es und stufen die Seite herab.'
		},
		{
			q: 'Ihr braucht in zwei Wochen Sichtbarkeit für die Weihnachtsaktion. Worauf setzt ihr?',
			o: [
				'SEO — es wirkt am schnellsten',
				'Bezahlte Anzeigen und Social Media — SEO braucht Wochen bis Monate',
				'Ausschließlich neue Meta-Beschreibungen',
				'Mehr Keywords in den Fließtext'
			],
			c: 1,
			e: 'SEO ist Langfristarbeit. Für kurzfristige Sichtbarkeit sind Anzeigen und die eigenen Kanäle da.'
		}
	],
	9: [
		{
			q: 'Ein Blogbeitrag „5 Ideen für selbstgemachte Weihnachtsgeschenke" gehört in welche Trichterphase?',
			o: ['TOFU — Aufmerksamkeit', 'MOFU — Interesse', 'BOFU — Kauf', 'In keine, das ist kein Marketing'],
			c: 0,
			e: 'Ein allgemein nützlicher Inhalt, der neue Leute anzieht, ohne direkt zu verkaufen: das ist die Spitze des Trichters.'
		},
		{
			q: 'Wann sind Google Ads gegenüber Meta Ads im Vorteil?',
			o: [
				'Wenn niemand euer Produkt kennt',
				'Wenn Menschen aktiv nach so einem Produkt suchen — die Kaufabsicht ist schon da',
				'Wenn ihr kein Budget habt',
				'Wenn ihr nur Bilder habt'
			],
			c: 1,
			e: 'Google holt bestehende Nachfrage ab (eher BOFU), Meta weckt Nachfrage bei passenden Menschen (eher TOFU und Retargeting).'
		},
		{
			q: 'Was ist beim Aufbau einer Newsletter-Liste rechtlich zwingend?',
			o: [
				'Ein vorausgefülltes Häkchen spart Zeit',
				'Aktive Einwilligung, Bestätigungsmail mit Link und ein Abmeldelink in jeder Aussendung',
				'Die Adressen dürfen aus dem Klassenverzeichnis übernommen werden',
				'Ab 100 Adressen braucht man keine Einwilligung'
			],
			c: 1,
			e: 'Werbe-E-Mails ohne Einwilligung sind unzulässig — auch an Bekannte. Double Opt-in und Abmeldelink sind Pflichtbestandteile.'
		},
		{
			q: 'Welche einzelne E-Mail-Automatisierung bringt im Onlinehandel erfahrungsgemäß am meisten?',
			o: [
				'Der monatliche Newsletter',
				'Die Erinnerung an den liegengebliebenen Warenkorb nach etwa 24 Stunden',
				'Die Geburtstagsmail',
				'Die Umfrage nach dem Kauf'
			],
			c: 1,
			e: 'Diese Menschen wollten schon kaufen. Eine freundliche Erinnerung holt einen Teil davon zurück — mit sehr geringem Aufwand.'
		},
		{
			q: 'Eure Persona ist 15 bis 18 Jahre alt, ihr habt noch keine Follower und im Schulalltag wenig Zeit. Welche Plattform passt am ehesten?',
			o: [
				'LinkedIn — dort sind die Firmen, die euch fördern könnten',
				'TikTok — Reichweite auch ohne Follower, und die Zielgruppe stimmt',
				'Facebook — die meisten Nutzer:innen insgesamt',
				'Alle vier gleichzeitig, um nichts zu verpassen'
			],
			c: 1,
			e: 'Drei Spalten des Vergleichs zeigen in dieselbe Richtung: Reichweite ohne Follower (hoch), Altersgruppe (13–25) und Eignung. Der Aufwand ist mittel — machbar. Vier Kanäle gleichzeitig sind der sichere Weg zu vier verwaisten Kanälen.'
		}
	],
	10: [
		{
			q: 'Eure Anzeigen kosten 5,20 € pro neuer Kundin, der Deckungsbeitrag je Bestellung beträgt 3,50 €. Was folgt daraus?',
			o: [
				'Weitermachen, Reichweite ist wichtiger',
				'Die Kampagne stoppen oder umbauen — ihr zahlt bei jeder Bestellung drauf',
				'Den Verkaufspreis senken',
				'Mehr Budget einsetzen, dann sinken die Kosten'
			],
			c: 1,
			e: 'Kosten je gewonnener Kundin über dem Deckungsbeitrag heißt Verlust pro Verkauf. Entweder Kampagne verbessern, Preis erhöhen oder abbrechen.'
		},
		{
			q: 'Warum darf ein A/B-Test immer nur eine Sache ändern?',
			o: [
				'Weil es sonst zu lange dauert',
				'Weil man sonst nicht weiß, welche Änderung für den Unterschied verantwortlich war',
				'Weil die Software nicht mehr zulässt',
				'Weil es sonst gegen die DSGVO verstößt'
			],
			c: 1,
			e: 'Werden Farbe, Text und Position gleichzeitig geändert, ist das Ergebnis nicht zuordenbar — und damit für die nächste Entscheidung wertlos.'
		},
		{
			q: 'Ihr verkauft am Schulmessestand und online. Was ist dabei am wichtigsten?',
			o: [
				'Am Stand höhere Preise verlangen',
				'Ein gemeinsamer Lagerstand, damit dasselbe Stück nicht zweimal verkauft wird',
				'Den Onlineshop während der Messe abschalten',
				'Am Stand keine Belege ausgeben'
			],
			c: 1,
			e: 'Getrennte Bestände sind die klassische Omnichannel-Falle: Der Messeverkauf muss sofort im Shop abgezogen werden.'
		},
		{
			q: 'Wie beurteilt das Bewertungsraster einen Konzepttext, der wie eine allgemeine KI-Definition ohne Bezug zur eigenen Company klingt?',
			o: [
				'9 – 10 Punkte, weil er fachlich korrekt ist',
				'1 – 3 Punkte: oberflächlich, generisch, ohne Anwendung',
				'4 – 6 Punkte, weil alle Leitfragen berührt sind',
				'0 Punkte, weil KI verboten ist'
			],
			c: 1,
			e: 'Das Raster nennt „generische KI-Texte ohne Bezug zum eigenen Projekt" ausdrücklich als Merkmal des Bereichs 1 – 3. KI als Entwurfshilfe ist erlaubt — der Bezug zur eigenen Company muss von euch kommen.'
		},
		{
			q: 'Wie geht ihr mit einer öffentlichen Ein-Stern-Bewertung um?',
			o: [
				'Löschen lassen',
				'Ignorieren',
				'Sichtbar, sachlich beantworten und wenn möglich eine Lösung anbieten',
				'Mit eigenen Fünf-Sterne-Bewertungen ausgleichen'
			],
			c: 2,
			e: 'Eine gut beantwortete negative Bewertung schafft mehr Vertrauen als lauter perfekte Bewertungen — und gefälschte Bewertungen sind unzulässig.'
		}
	]
}
